import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RightIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Right",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.52 15.26c-.06-.11-.12-.21-.19-.3s-.11-.17-.11-.17v-.08L11.57 2.5c-.32-.31-.75-.5-1.23-.5-.97 0-1.75.78-1.75 1.75 0 .43.15.82.41 1.13S19.5 15.9 19.5 15.9L9 26.93c-.37.32-.59.79-.59 1.32 0 .97.78 1.75 1.75 1.75.55 0 1.05-.26 1.37-.66s11.65-12.2 11.65-12.2v-.08l.11-.18c.07-.09.13-.19.18-.29.03-.1.05-.21.07-.32.03-.1.05-.22.06-.33 0-.13-.03-.24-.06-.35s0-.03 0-.05c0-.1 0-.2-.02-.29Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M11 27.71c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l9.48-9.48-9.48-9.47a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0L22.1 15.48c.45.45.45 1.17 0 1.62L11.81 27.39c-.22.22-.52.33-.81.33Z"
      })
    })
  }));
};
RightIcon.displayName = 'RightIcon';